export const isClient = () => {
  return typeof process.client === 'boolean' ? process.client : true;
};
